import { TaskActionType } from '@griply/types';

// Every current action type is a "timeslot" block whose completion is read straight off `completedAt`.
const timeslotActionTypes = [
  TaskActionType.GoalTimeslot,
  TaskActionType.LifeAreaTimeslot,
  TaskActionType.TagTimeslot,
  TaskActionType.SmartListTimeslot,
];

export const isTimeslotAction = (type: TaskActionType | undefined): boolean =>
  !!type && timeslotActionTypes.includes(type);
